import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { SaldoRequestModel } from '../../models/saldo/saldo-request.model';
import { Saldo } from '../../models/client-models';

const SALDO_ENDPOINT = 'saldo';

@Injectable({
  providedIn: 'root',
})
export class SaldoBackendService {
  constructor(private http: HttpClient) {}

  public getSaldo(saldoRequest: SaldoRequestModel) {
    return this.http.post<Saldo>(
      AppConfig.settings.backend.url + SALDO_ENDPOINT,
      saldoRequest
    );
  }
}
